/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Callback_Contact_InvalidInputs */

const en_error_callback_contact_invalid = /** @type {(inputs: Error_Callback_Contact_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a contact of the user's organization with a phone on record.`)
};

/**
* | output |
* | --- |
* | "Choose a contact of the user's organization with a phone on record." |
*
* @param {Error_Callback_Contact_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_callback_contact_invalid = /** @type {((inputs?: Error_Callback_Contact_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Callback_Contact_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_callback_contact_invalid(inputs)
});